import React, { Component } from 'react'
import PropTypes from 'prop-types'


import * as echarts from 'echarts/core'
import { GridComponent } from 'echarts/components'
import { BarChart } from 'echarts/charts'
import { CanvasRenderer } from 'echarts/renderers'
echarts.use(
    [GridComponent, BarChart, CanvasRenderer]
)

/**
 * 评分报告
 */
export default class MonthLoanCmountChat12 extends Component {

    static propTypes = {
        data: PropTypes.array,
    }

    componentDidMount() {
        const myChart = echarts.init(document.getElementById('12_month_loan_amount_chat_chat'))
        this.setState({ myChart }, this.setData)
    }

    componentDidUpdate() {
        this.setData()
    }

    setData(data = this.props.data) {
        this.state.myChart.setOption({
            title: {
                text: '近12个月贷款数'
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            legend: {},
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01]
            },
            yAxis: {
                type: 'category',
                data: ['1k及以下', '1k-3k', '3k-10k', '1w以上']
            },
            series: [
                {
                    name: '笔数',
                    type: 'bar',
                    data
                }
            ]
        })
    }

    render() {

        return (
            <>
                <div id="12_month_loan_amount_chat_chat" style={{ width: 400, height: 200 }} />
            </>)
    }
}